import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const BANK_CARDS_ENDPOINTS = {
  V1: createEndpoints('v1', {
    BANKS: '/banks/',
    ALL_BANKS: '/all-banks/',
    BANK_DETAIL: (id: number) => `/banks/${id}/`,
  }),
} as const;
